import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import type { Tagged } from "@-/com.npmjs.type-fest";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";
import { GraphemeMorphemePanelsContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._context";

export type MorphemeMnemonicsMeaningViewTitleSectionGate = Tagged<
  { title: string },
  "MorphemeMnemonicsMeaningViewTitleSectionGate"
>;

/** Whether the meaning view shows its title. `null` is the designed hidden state: no back. */
export function useMorphemeMnemonicsMeaningViewTitleSectionGate(): MorphemeMnemonicsMeaningViewTitleSectionGate | null {
  const [title] = useContextSelectors(
    GraphemeMorphemePanelsContext,
    (c) => c.readonlySlice.data.back,
  );
  return title === undefined || title === ""
    ? null
    : createGate<MorphemeMnemonicsMeaningViewTitleSectionGate>({ title });
}
